<template>
  <header
   class="main-header" ref="mainHeader">
      <a href="/" class="main-header__logo" @click="close">
        <svg width="119" height="46" viewBox="0 0 119 46" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_408_787)">
          <path d="M118.274 10.0613V1.42794H87.1123V44.5717H118.274V35.943H95.7963V27.3188H114.395V18.6855H95.7963V10.0613H118.274Z" fill="black"/>
          <path d="M22.6422 0.502502C10.1576 0.502502 0 10.5952 0 23.0002C0 35.4052 10.1576 45.4979 22.6422 45.4979C35.1268 45.4979 45.2844 35.4052 45.2844 23.0002C45.289 10.5952 35.1314 0.502502 22.6422 0.502502ZM22.6422 36.8737C14.9448 36.8737 8.68417 30.653 8.68417 23.0048C8.68417 15.3566 14.9448 9.13582 22.6422 9.13582C30.3395 9.13582 36.6002 15.3566 36.6002 23.0048C36.6002 30.653 30.3395 36.8737 22.6422 36.8737Z" fill="black"/>
          <path d="M71.0429 27.2875C78.1435 27.2875 84.0645 21.6414 84.2435 14.7001C84.3353 11.1792 83.0272 7.85451 80.5532 5.33703C78.0839 2.81955 74.7745 1.43311 71.2357 1.43311H47.166V44.5723H55.8502V10.0619H71.2357C72.4107 10.0619 73.5122 10.5225 74.3339 11.3616C75.1555 12.2008 75.5915 13.3045 75.5594 14.4766C75.4997 16.7843 73.4709 18.6587 71.0383 18.6587H67.1185C63.7219 18.6587 60.6879 20.6745 59.3891 23.7895C58.0901 26.9044 58.7969 30.4616 61.1975 32.8515L72.9844 44.5769H85.2626L67.885 27.2921H71.0383L71.0429 27.2875Z" fill="black"/>
          </g>
          <defs>
          <clipPath id="clip0_408_787">
          <rect width="118.274" height="45" fill="white" transform="translate(0 0.502502)"/>
          </clipPath>
          </defs>
        </svg>
      </a>
      <div>
        <nav class="main-header__nav">
          <MainMenu name="main-menu" />
        </nav>
        <!-- <a href="#" class="main-header__quote-btn">
          Quotes
          <span id="js-quotes-count"></span>
        </a> -->
        <QuotesWidget :class="{active: activeState}" />
        <button class="main-header__menu-toggle" @click="toggle" :class="{ active: activeState }">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <!-- <div
          class="hamburguer"
          @click="toggle"
          :class="{ active: activeState }"
        >
          <div class="line" />
          <div class="line" />
        </div> -->
      </div>
    <SecondaryMenu
      :primaryMenu="mainMenu"
      :secondaryMenu="secondaryMenu"
      :active="activeState"
      @updated-state="toggle"
    />
  </header>
</template>

<script setup>
import { ref, onUnmounted, onBeforeMount, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import SecondaryMenu from './SecondaryMenu.vue'
import QuotesWidget from './QuotesWidget.vue'
import MainMenu from './MainMenu.vue'

const store = useStore()
const mainMenu = store.getters.menu({ name: 'main-menu' })
const secondaryMenu = store.getters.menu({ name: 'secondary-menu' })
const site = store.getters.acfOptions()
const activeState = ref(false)
const curr = getCurrentInstance()
const scrollTop = ref(0)
const scrolling = ref(false)
const mainHeader = ref(null)
const lastScrollTop = ref(0)

function toggle () {
  activeState.value = !activeState.value
  const html = document.querySelector('html')

  if (activeState.value === true) {
    html.classList.add('no-overflow')
    curr.root.data.locoScroll.stop()
  } else {
    html.classList.remove('no-overflow')
    curr.root.data.locoScroll.start()
  }
}

function close () {
  if (activeState.value === true) {
    toggle()
  }
}

function closeHandler (e) {
  if (e.keyCode === 27 && activeState.value === true) {
    toggle()
  }
}

function handleScroll () {
  const currentScrollTop = window.scrollY
  const scrollDirection = currentScrollTop > lastScrollTop.value ? 'down' : 'up'
  
  // Update scroll direction tracking
  lastScrollTop.value = currentScrollTop
  scrollTop.value = currentScrollTop
  
  // Add/remove 'is-hidden' class based on scroll direction
  if (mainHeader.value) {
    if (scrollDirection === 'down') {
      mainHeader.value.classList.add('is-hidden')
    } else {
      mainHeader.value.classList.remove('is-hidden')
    }
  }
  
  // Add 'is-scrolled' class when scrollY is greater than 50% viewport height
  const scrollThreshold = window.innerHeight * 0.5
  
  if (mainHeader.value) {
    if (scrollTop.value > scrollThreshold) {
      mainHeader.value.classList.add('is-scrolled')
    } else {
      mainHeader.value.classList.remove('is-scrolled')
    }
  }
  
  // Keep existing threshold logic for backward compatibility
  if (scrollTop.value > scrollThreshold) {
    scrolling.value = true
  } else {
    scrolling.value = false
  }
}

onBeforeMount(() => {
  document.addEventListener('keyup', closeHandler, { passive: true })
  window.addEventListener('scroll', handleScroll, { passive: true })
})

onUnmounted(() => {
  document.removeEventListener('keyup', closeHandler, false)
  window.removeEventListener('scroll', handleScroll, false)
})
</script>

<style lang="scss" scoped>
#header-nav {
  @apply fixed bg-transparent w-full z-10 pt-3 pb-1 lg:py-1;

  // nav {
  //   @apply flex flex-row items-center justify-between pl-6 pr-2 md:px-5 2xl:px-0 max-w-[1600px] m-auto relative z-10;
  //   .logo-container {
  //     @apply w-20 md:w-36;
  //   }
  //   .wrap-nav {
  //     @apply flex flex-row items-center xl:max-w-[1200px];

  //     ul {
  //       @apply flex flex-row items-center content-end transition-all duration-300 w-full justify-end lg:justify-between lg:px-4 lg:gap-5 lg:mr-5 lg:min-h-[54px] xl:gap-14 xl:px-8 2xl:gap-20;

  //       li {
  //         @apply w-auto text-center text-xl font-normal pointer-events-auto ease-in delay-[200ms] duration-500;

  //         &.menu-item {
  //           @apply hidden lg:block;

  //           a {
  //             @apply relative inline-block;
  //             &:before {
  //               @apply bg-black content-[''] w-0 h-px block absolute -bottom-2 ease-out duration-500;
  //             }

  //               &:after {
  //               @apply content-[''] absolute w-1 h-1 bg-ore_mint -left-2 top-[calc(50%_-_2px)] rounded-full opacity-0 xl:w-2 xl:h-2 xl:-left-3 xl:top-[calc(50%_-_4px)] transition-all 2xl:-left-4;
  //             }

  //             &:hover {
  //               &:before {
  //                 @apply w-full ease-out duration-500;
  //               }
  //             }

  //               &.router-link-active,
  //             &.router-link-exact-active {
  //                &:before {
  //                 @apply w-full ease-out duration-500;
  //               }
  //             }
  //           }
  //         }
  //       }

  //       &.scrolling {
  //         @apply bg-ore_green_dark/70 backdrop-blur rounded-full;

  //         li {
  //           a {
  //             @apply text-white relative;

  //             &.router-link-active,
  //             &.router-link-exact-active {
  //               &:after {
  //                 @apply opacity-100;
  //               }

  //               &:before{
  //                 @apply w-0;
  //               }

  //               &:hover{
  //                 &:after{
  //                   @apply bg-ore_orange;
  //                 }
  //               }
  //             }

  //             &:hover{
  //               &:before{
  //                 @apply hidden;
  //               }

  //                &:after {
  //                 @apply opacity-100;
  //               }
  //             }
  //           }
  //         }
  //       }

  //     &.active {
  //       @apply lg:pointer-events-none lg:-translate-y-[160px] lg:delay-300 lg:duration-700 lg:ease-in-out;
  //     }
  //     }

  //     .hamburguer {
  //       @apply flex-[1_0_auto] flex flex-col items-center justify-center rounded-full border border-black transition duration-300 ease-in-out ml-0  w-[70px] h-[70px] md:w-[90px] md:h-[90px] lg:w-[120px] lg:h-[120px] lg:ml-4 xl:ml-14 2xl:ml-20;
  //       .line {
  //         @apply w-[40px] h-[3px] bg-black my-[6px] transition duration-300 ease-in-out md:w-[36px] lg:my-[10.5px] lg:w-[48px];
  //       }

  //       &:hover {
  //         @apply scale-75 cursor-pointer;
  //         .line {
  //           @apply my-[5.5px] lg:my-[9.5px] ease-in-out duration-300;
  //         }
  //       }

  //       &.active {
  //         @apply scale-100;

  //         .line {
  //           &:first-child {
  //             @apply transform rotate-45  w-[30px] translate-x-[1px] translate-y-[8px] md:w-[35px] md:translate-x-[3px] md:translate-y-[8px] lg:w-[48px] lg:translate-x-[3px] lg:translate-y-[12px];
  //           }
  //           &:last-child {
  //             @apply transform -rotate-45  w-[30px] translate-x-[1px] translate-y-[-7px] md:w-[35px] md:translate-x-[2px] md:translate-y-[-7px] lg:w-[48px] lg:translate-x-[2px] lg:translate-y-[-12px];
  //           }
  //         }

  //         &:hover {
  //           .line {
  //             @apply my-[6px] lg:my-[10.5px];
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
}
</style>
